import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NuvemEnvioBillingType } from '@tiendanube/common/src/enums';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioConfigsAction,
  getNuvemEnvioConfigsData,
  getNuvemEnvioConfigsStatus,
} from '../../deliveryMethodsSlice';

function useGetNuvemEnvioConfigs() {
  const dispatch = useAppDispatch();
  const nuvemEnvioConfigs = useSelector(getNuvemEnvioConfigsData);
  const status = useSelector(getNuvemEnvioConfigsStatus);
  const hasFetchedRef = useRef(false);

  const fetchNuvemEnvioConfigs = useCallback(
    () => dispatch(getNuvemEnvioConfigsAction()),
    [dispatch],
  );

  useEffect(() => {
    if (status.isIdle && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchNuvemEnvioConfigs();
    }
  }, [fetchNuvemEnvioConfigs, status]);

  return {
    nuvemEnvioConfigs,
    fetchNuvemEnvioConfigs,
    status,
    isPostPaid:
      nuvemEnvioConfigs.billingType === NuvemEnvioBillingType.POST_PAID,
  };
}

export default useGetNuvemEnvioConfigs;
